import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import { authApi } from '@@/services/auth';

interface ModalState {
  showUserProfileModal: boolean;
  showSearchPartnerPropertiesModal: boolean;
  showAddIncidentCommentModal: boolean;
  showAddIncidentInternalNoteModal: boolean;
  showAddIncidentAdminModal: boolean;
  showAddAuthorizedGroupModal: boolean;
  showEditIncidentTypeModal: boolean;
}

const initialState = {
  showUserProfileModal: false,
  showSearchPartnerPropertiesModal: false,
  showAddIncidentCommentModal: false,
  showAddIncidentInternalNoteModal: false,
  showAddIncidentAdminModal: false,
  showAddAuthorizedGroupModal: false,
  showEditIncidentTypeModal: false,
} as ModalState;

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openUserProfileModal(state) {
      state.showUserProfileModal = true;
    },
    hideUserProfileModal(state) {
      state.showUserProfileModal = false;
    },
    openSearchPartnerPropertiesModal(state) {
      state.showSearchPartnerPropertiesModal = true;
    },
    hideSearchPartnerPropertiesModal(state) {
      state.showSearchPartnerPropertiesModal = false;
    },
    openAddIncidentCommentModal(state) {
      state.showAddIncidentCommentModal = true;
    },
    hideAddIncidentCommentModal(state) {
      state.showAddIncidentCommentModal = false;
    },
    openAddIncidentInternalNoteModal(state) {
      state.showAddIncidentInternalNoteModal = true;
    },
    hideAddIncidentInternalNoteModal(state) {
      state.showAddIncidentInternalNoteModal = false;
    },
    openAddIncidentAdminModal(state) {
      state.showAddIncidentAdminModal = true;
    },
    hideAddIncidentAdminModal(state) {
      state.showAddIncidentAdminModal = false;
    },
    openAddAuthorizedGroupModal(state) {
      state.showAddAuthorizedGroupModal = true;
    },
    hideAddAuthorizedGroupModal(state) {
      state.showAddAuthorizedGroupModal = false;
    },
    openEditIncidentTypeModal(state) {
      state.showEditIncidentTypeModal = true;
    },
    hideEditIncidentTypeModal(state) {
      state.showEditIncidentTypeModal = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state = initialState;
    });

    builder.addMatcher(authApi.endpoints.logout.matchFulfilled, () => {
      return initialState;
    });
  },
});

export const {
  openUserProfileModal,
  hideUserProfileModal,
  openSearchPartnerPropertiesModal,
  hideSearchPartnerPropertiesModal,
  openAddIncidentCommentModal,
  hideAddIncidentCommentModal,
  openAddIncidentInternalNoteModal,
  hideAddIncidentInternalNoteModal,
  openAddIncidentAdminModal,
  hideAddIncidentAdminModal,
  openAddAuthorizedGroupModal,
  hideAddAuthorizedGroupModal,
  openEditIncidentTypeModal,
  hideEditIncidentTypeModal,
} = modalSlice.actions;

export default modalSlice;
